function registerClickEvents() {
    document.querySelectorAll('.copyable-text__button').forEach(function (button) {
        button.addEventListener('click', onCopyClick);
    });
}

function onCopyClick(event) {
    const messageElement = event.target.parentElement.querySelector('.copyable-text__message');
    const message = messageElement.innerText;

    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(message).then(
            function () {
                showCopySuccess(event.target);
            },
            function () {
                console.error('Could not copy message to clipboard');
            },
        );
    } else {
        const textArea = document.createElement('textarea');
        textArea.value = message;
        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            showCopySuccess(event.target);
        } catch (err) {
            console.error('Fallback: Could not copy message to clipboard', err);
        }

        document.body.removeChild(textArea);
    }
}

function showCopySuccess(button) {
    button.classList.add('copyable-text__button--successfully-copied');
    setTimeout(function () {
        button.classList.remove('copyable-text__button--successfully-copied');
    }, 1000);
}

registerClickEvents();
